import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Cookies from 'js-cookie';
import io from 'socket.io-client';
import {
  viewImage,
  updateUserProfileImage,
  deleteImage,
} from '../../services/usersServives';
import { ProfileNavBar } from './profileNavBar';
import { Page } from '../../components/page';
import { useTranslation } from 'react-i18next';
import { localisations } from '../../localisations';
localisations();
const baseURL = process.env.REACT_APP_BASE_URL_DOCUMENT;

function EditUserLogo({ children, ui, epr, edpr, epic, elog, ...props }) {
  const [userLogo, setUserLogo] = useState('');
  const [userLogoError, setUserLogoError] = useState(null);
  const [userLogoDisplay, setUserLogoDisplay] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    async function getData() {
      viewImage()
        .then((response) => {
          setUserLogo(response.data.userLogo);
          setUserLogoDisplay(response.data.userLogo);
        })
        .catch((error) => {
          if (error.response.data.userError) {
            Cookies.remove('token');
            Cookies.remove('creadUseDetail');
            props.history.push('/');
            window.location.reload();
          }
        });
    }
    async function clientSocket() {
      const socket = io(baseURL);
      const userId = Cookies.get('creadUseDetail');

      // Socket for update user record
      socket.on('updateUser', (ms) => {
        if (userId === ms) {
          getData();
        }
      });
    }
    clientSocket();
    getData();
  }, [props.history]);

  const handleChange = (e) => {
    const userLogo = e.target.files[0];
    setUserLogo(userLogo);
  };
  async function handleSubmit() {
    if (userLogo === undefined) {
      props.history.push(ui);
    } else {
      editData();
    }
  }
  async function editData() {
    const data = new FormData();
    data.append('userLogo', userLogo);
    updateUserProfileImage(data)
      .then((response) => {
        const socket = io(baseURL);
        const userId = Cookies.get('creadUseDetail');
        socket.emit('user', `${userId}`);
        socket.emit('updateUser', `${userId}`);
      })
      .catch((error) => {
        if (error.response.data.userError) {
          Cookies.remove('token');
          Cookies.remove('creadUseDetail');
          props.history.push('/');
          window.location.reload();
        }
      });
  }

  async function deleteLogo() {
    if (window.confirm('Are you sure you want to delete this image?')) {
      deleteImage()
        .then((response) => {
          const socket = io(baseURL);
          const userId = Cookies.get('creadUseDetail');
          socket.emit('user', `${userId}`);
          socket.emit('updateUser', `${userId}`);
        })
        .catch((error) => {
          if (error.response.data.userError) {
            Cookies.remove('token');
            Cookies.remove('creadUseDetail');
            props.history.push('/');
            window.location.reload();
          }
        });
    }
  }

  return (
    <Page title={t('dProfilePicture')} content={t('dDocumentContent')} href="/">
      <div className="row">
        {children}
        <div className="col-md-9 col-12">
          <div className="col-12">
            <div className="card">
              <ProfileNavBar epr={epr} edpr={edpr} epic={epic} elog={elog} />
              <div className="card-body">
                <div className="col-12 user-detail-record">
                  <div className="row form-row">
                    <div className="detail-title col-12">
                      <h5>{t('profileImage')}</h5>
                    </div>
                    <div className="col-12 ImageSt">
                      {userLogoDisplay ? (
                        <img
                          src={`${baseURL}/images/${userLogoDisplay}`}
                          height="150"
                          width="150"
                          alt=""
                        />
                      ) : (
                        <img
                          width="150"
                          height="150"
                          src="/images/banner/placeholder.png"
                          alt=""
                        />
                      )}
                    </div>
                    <div className="col-md-6 col-12 form-group">
                      <label>
                        {t('userProfile')}
                        <i className="required-detail">*</i>
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        name={userLogo}
                        placeholder="user profile"
                        accept=".jpg, .png, .jpeg"
                        onChange={handleChange}
                      />
                      {userLogoError ? (
                        <p className="errorMessage"> {userLogoError}</p>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="container row">
                  <div className="col-6">
                    <Link
                      to="#"
                      onClick={() => handleSubmit()}
                      className="btn-style btn-info"
                    >
                      {t('update')}
                    </Link>
                  </div>
                  <div className="col-6">
                    <Link
                      to="#"
                      onClick={() => deleteLogo()}
                      className="btn-style btn-danger"
                    >
                      {t('delete')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default withRouter(EditUserLogo);
